<app-ion-common-header
  [id]="headerId"
  (backHeader)="backPage()"
  (focusHeader)="shownContent(); scrollContentToTop()"
  [title]="titlePage"
  start="{{ startStage }}"
  end="{{ endStage }}"
></app-ion-common-header>

<app-loading-circle *ngIf="loading"> </app-loading-circle>

<ion-content
  *ngIf="!showRetry && !loading"
  [attr.aria-hidden]="ariaHidden"
  [style.visibility]="ariaHidden ? 'hidden' : 'visible'"
>
  <div
    #content
    class="content-list content-scroll"
    [ngClass]="{ 'content-list--with-button': selectedItem }"
  >
    <app-ion-common-label
      [id]="idLabelIssuingAgency"
      class="document-type-label1"
      labelStyle="display-rg"
      [labelDescription]="titleLabelPage"
    >
    </app-ion-common-label>
    <div class="conent-center conent-center--mrt-lg">
      <div class="my-search">
        <app-ion-common-search
          [id]="idInputIssuingAgency"
          [textSearch]="textSearch"
          [ariaLabel]="'Busque por órgãos expedidores'"
          [placeholder]="'Busque por órgãos expedidores'"
          [list]="documentIssuing"
          [fieldSearch]="fieldSearch"
          [textError]="'Órgão expedidor não encontrado'"
          (sendTextSearch)="textSearch = $event"
        >
        </app-ion-common-search>
      </div>
      <app-ion-common-radio
        [id]="idRadioIssuingAgency"
        class="document-type-options"
        [itens]="documentIssuing"
        [selectedValue]="selectedItem"
        [disabled]="!this.edit"
        [textSearch]="textSearch"
        [fieldSearch]="fieldSearch"
        (changeRadio)="selectedItem = $event; changeValue()"
        (valueNameRadio)="selectedName = $event"
      >
      </app-ion-common-radio>
    </div>
  </div>

  <app-ion-common-button
    [id]="idButtonIssuingAgency"
    class="hidden"
    [ngClass]="{ hidden: selectedItem?.length === 0 }"
    [attr.aria-hidden]="selectedItem?.length === 0"
    label="Continuar"
    (clickButton)="clickNext()"
  ></app-ion-common-button>
</ion-content>

<ion-content *ngIf="showRetry">
  <app-ion-common-retry
    [id]="idRetryIssuingAgency"
    [headerId]="headerId"
    (sendEventRetry)="getDomainIssuing()"
  >
  </app-ion-common-retry>
</ion-content>
